import ValidatorResult from "../classes/validator.results";
export default class RequiredValidationRule {
    name = 'required';
    validate(validation, rules, value, object, manager) {
        let tMessage = host.localizer?.tc('system.Validation.Required', [validation.displayName]);
        if (value === null) {
            return new ValidatorResult(false, tMessage);
        }
        let type = typeof value;
        if (type === 'undefined' || type === null)
            return new ValidatorResult(false, tMessage);
        if (type == "boolean") {
            if (value) {
                return new ValidatorResult(true);
            }
            else {
                return new ValidatorResult(false, tMessage);
            }
        }
        if (/(string|array|number)/.test(type) === false) {
            return new ValidatorResult(false, tMessage);
        }
        if (value.toString().length === 0) {
            return new ValidatorResult(false, tMessage);
        }
        return new ValidatorResult(true);
    }
}
